import { MappingPanelPosition } from '../MappingEditorStore';
import { LEFT_COLUMN_EDGE } from './MappingConnectors';
import { IMappingConnectorHoverProps } from './MappingConnectorUtils';

export interface IRowHoveredMappingConnectorProps extends IMappingConnectorHoverProps {
  rightEdge: number;
  clipPath: string;
}

export function RowHoveredMappingConnector({
  clipPath,
  startSide,
  startY,
  rightEdge,
}: IRowHoveredMappingConnectorProps) {
  const x = startSide === MappingPanelPosition.LEFT ? LEFT_COLUMN_EDGE : rightEdge;
  return (
    <circle
      cx={x}
      cy={startY}
      r="4"
      fill="white"
      className="dp-row-hovered-mapping-connector__point"
      clipPath={clipPath}
    />
  );
}
